import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AthleteHub } from "@/features/athlete-hub/athlete-hub";
import { HUB_TABS, type HubTab } from "@/features/athlete-hub/hub-tabs";
import { useAthletePlans, useAthleteProfile } from "@/features/training/hooks/use-athlete-profile";
import { CoachedStrip } from "@/features/training/modules/coached-live/components/coached-strip";
import { HistoryBoard } from "@/features/training/modules/history/history-board";
import { AthletePlans, NewPlanButton } from "@/features/training/modules/plans/athlete-plans";
import { RecoveryBoard } from "@/features/training/modules/recovery/recovery-page";
import { TrainingHomeCard, useTrainingHero } from "@/features/training/modules/training-home/training-home-card";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/training/")({
  loader: () => ({ crumb: m.hub_nav() }),
  // The tab lives in the URL, so "recovery" is a link and Back steps between tabs.
  validateSearch: z.object({ tab: z.enum(HUB_TABS).optional().catch(undefined) }),
  component: TrainingPage,
});

function TrainingPage() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  const hero = useTrainingHero();
  const profile = useAthleteProfile();
  const plans = useAthletePlans();
  return (
    <AthleteHub
      tab={tab ?? "today"}
      own={{
        today: (
          <div className="grid gap-4">
            <CoachedStrip />
            <TrainingHomeCard />
          </div>
        ),
        plans: <AthletePlans />,
        recovery: <RecoveryBoard />,
        history: <HistoryBoard />,
        planned: Boolean(profile.data?.training.savedAt),
        planCount: plans.data?.length ?? 0,
        plansAction: plans.data?.length ? <NewPlanButton /> : null,
      }}
      description={hero.description}
      actions={hero.actions}
      onTabChange={(next: HubTab) => void navigate({ search: next === "today" ? {} : { tab: next }, replace: true })}
    />
  );
}
